<template>
  <v-container class="fill-height agencies" fluid style="min-height:100vh; background:#FFE7D7;">
    <v-row>
      <v-spacer/>
      <div>
        <v-row class="ma-0">
          <v-spacer/>
            <div>
              <v-img width="300" src="/PeachAgency-LogoBlack.png"/>
            </div>
          <v-spacer/>
        </v-row>
        <v-row class="ma-0">
          <v-spacer/>
            <v-card-title>Portal de Agencias</v-card-title>
          <v-spacer/>
        </v-row>
        <v-row class="ma-0">
          <v-spacer/>
            <v-card-subtitle>Completa tus datos para acceder</v-card-subtitle>
          <v-spacer/>
        </v-row>
        <v-row class="ma-0">
          <v-spacer/>
            <div style="width:450px;">
              <!--v-text-field 
                :rules="[rules.required, rules.email]"
                @keydown.enter="login" 
                label="Email" 
                name="login" 
                type="email" 
                v-model="user.email" 
                aria-describedby="emailHelp"
                rounded
                hide-details="auto"
              /-->

              <v-text-field 
                :rules="[rules.required, rules.passwordStrong]"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                name="password"
                label="Contraseña"
                hint="8 caracteres (1 mayúscula, 1 número y 1 carácter especial)"
                @click:append="show1 = !show1"
                @keydown.enter="login" 
                v-model="password.password"
                rounded
                :hide-details="false"
                class="pt-5"
              />

              <v-text-field 
                :rules="[rules.required, passwordsMatch]"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                name="password_confirmation"
                label="Confirmar Contraseña"
                @click:append="show2 = !show2"
                @keydown.enter="login" 
                v-model="password.password_confirmation"
                rounded
                :hide-details="false"
                class="pt-0"
              />

              <v-btn
                block
                :loading="loading"
                :disabled="loading || !isPasswordValid || password.password !== password.password_confirmation"
                color="primary"
                type="submit"
                @click="login"
                class="elevation-0 py-7"
                rounded
              >
                <strong>Acceder</strong>
              </v-btn>
            </div>
          <v-spacer/>
        </v-row>
      </div>
      <v-spacer/>
    </v-row>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.message }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios"

// Regex: mínimo 8 caracteres, al menos 1 minúscula, 1 mayúscula, 1 número y 1 carácter especial (sin espacios)
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])\S{8,}$/

export default {
  data:()=>({
    rules: {
      required: value => !!value || 'Requerido.',
      /*email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'E-mail inválido.'
      },*/
      passwordStrong: value => {
        const ok = PASSWORD_REGEX.test(String(value || ''))
        return ok || 'La contraseña no cumple los requisitos.'
      }
    },
    password:{
      password: "",
      password_confirmation:""
    },
    show1:false,
    show2:false,
    loading:false,
    snackbar: {
      show: false,
      message: null,
      color: null
    },
    token:''
  }),
  created(){
    this.token = this.$route.query.t
  },
  computed:{
    isPasswordValid(){
      return PASSWORD_REGEX.test(String(this.password.password || ''))
    }
  },
  methods:{
    passwordsMatch (value){
      return value === this.password.password || 'Las contraseñas no coinciden.'
    },
    login(){
      if (!this.isPasswordValid) {
        this.snackbar = { show:true, color:'error', message:'La contraseña no cumple los requisitos.' }
        return
      }
      if (this.password.password !== this.password.password_confirmation) {
        this.snackbar = { show:true, color:'error', message:'Las contraseñas no coinciden.' }
        return
      }
      this.loading = true
      let config = {
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }
      axios.patch(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/user/password", this.password, config)
        .then(()=>{
          localStorage.setItem("xn8(*&^%$#47b*g3f76gw3*&^fn734gf8q*&^&^&mwmeg934g8whmre7ngN&G#*!NG@*&#GF(!*#gm1n428fm1g3n84gmf*^$&(%$)e3298negmg", this.token);
          localStorage.removeItem("nosepudo");
          window.location.replace("#/");
          location.reload();
        })
        .catch(()=>{
          this.snackbar = { show:true, color:'error', message:'No se pudo establecer la contraseña.' }
        })
        .finally(()=>{
          this.loading = false
        })
    }
  }
}
</script>

<style>
.agencies .v-input__slot {
  background:#F4F4F4;
  padding:10px 20px!important;
}
</style>
